<ng-container *ngFor="let display of values">
    <div class="grid grid-flow-col justify-between mat-label-medium py-2 business-values-row">
        <span class="mat-label-medium text-lendio-cool-gray-900">{{display.shortName || ''}}</span>
        <span class="mat-body-medium">
            <ng-container [ngSwitch]="display.type">
                <ng-container *ngSwitchCase="'currency'">
                    {{(display.value | currency) || 'N/A'}}
                </ng-container>
                <ng-container *ngSwitchCase="'bool'">
                    {{(display.value ? 'Yes' : 'No') || 'N/A'}}
                </ng-container>
                <ng-container *ngSwitchDefault>
                    {{ display.value || 'N/A' }}
                </ng-container>
            </ng-container>
        </span>
    </div>
</ng-container>
